import * as React from 'react';
import PinInput from 'react-pin-input';
import { polyglot } from '../../helpers/Polyglot';
import { LocalesKeys } from '../../localesKeys';
import styles from './PinInput.scss';

export interface PinInputsProps {
    setCode: (code: string) => void;
    activationStatus: string;
    setActivationStatus: (statuus: string) => void;
    inputError:  boolean;
}

export const PinInputs = ({ setCode, activationStatus, setActivationStatus, inputError }: PinInputsProps) => {
    let pinInput;
    React.useEffect(() => {
        if (activationStatus === 'error') {
            pinInput.clear();
            setActivationStatus('pending');
        }
    }, [activationStatus]);

    // Added for test automation
    React.useEffect(() => {
        document.querySelectorAll('.pincode-input-text').forEach((input, index) => {
            input.setAttribute('id', `pinInput${index}`);
        });
    }, []);

    return(
       <>
           <PinInput
               length={6}
               initialValue= ''
               secret={false}
               onChange={(value, index) => { setCode(value); }}
               type='numeric'
               inputMode='number'
               inputStyle={{borderColor: inputError ? 'red' : '#D8D8D8' }}
               inputFocusStyle={{borderColor: '#006aff'}}
               onComplete={(value, index) => { setCode(value); }}
               ref={(n) => pinInput = n}
           />
           {inputError && <div id='error' className={styles.ErrorText}>{polyglot.t(LocalesKeys.invalidCode)}</div>}
       </>
    );
};
